const faqs = [
  {
    q: '老子影视网的电视剧都是免费观看的吗？',
    a: '是的，老子影视网所有电视剧均支持免费在线观看，涵盖国产剧全集、韩剧全集以及最新电视剧，无需付费即可畅享高清画质播放体验。',
  },
  {
    q: '播放电视剧会卡顿吗？画质怎么样？',
    a: '我们采用先进的视频加速技术，确保播放流畅不缓冲。全站剧集均提供高清分辨率，画质清晰细腻，为您带来舒适的追剧体验。',
  },
  {
    q: '需要下载App或者注册账号才能观看吗？',
    a: '不需要。老子影视网直接在浏览器中打开即可观看，无需下载任何App，也无需注册账号，即开即看，方便快捷。',
  },
  {
    q: '更新速度怎么样？能跟上卫视首播吗？',
    a: '我们的内容团队每日同步更新，国产剧和韩剧的最新剧集都会在第一时间上线，确保您不会错过任何精彩更新。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          关于老子影视网的常见疑问解答
        </p>
        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-5 border border-background-200/60">
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                {item.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}